import type { ComponentType, SVGProps } from "react"
import {
  BinanceIcon,
  BitmaxIcon,
  BitpinIcon,
  BybitIcon,
  ExirIcon,
  GateIcon,
  LbankIcon,
  NobitexIcon,
  RamzinexIcon,
  WallexIcon
} from "@/app/components/UI/Icons"

export type ExchangeIcon = ComponentType<SVGProps<SVGSVGElement>>

const exchangeIconMap: Record<string, ExchangeIcon> = {
  binance: BinanceIcon,
  bitmax: BitmaxIcon,
  bitpin: BitpinIcon,
  bybit: BybitIcon,
  exir: ExirIcon,
  gate: GateIcon,
  lbank: LbankIcon,
  nobitex: NobitexIcon,
  ramzinex: RamzinexIcon,
  wallex: WallexIcon,
}

export const getExchangeIcon = (exchange?: string): ExchangeIcon | null => {
  if (!exchange) return null
  return exchangeIconMap[exchange.toLowerCase()] ?? null
}
